// The shared 90 s inactivity deadline, shown on the guest pages after the face gallery (body gallery, edit, result)
// with the same wording family and look as the gallery timer. Display only: it never moves the deadline. Renders
// nothing when the deadline is not enforced or is paused (see useFlowCountdown).
// variant "fixed": a thin line inside the top padding of a page whose title is position:fixed (result pages).
import React from "react";
import { formatSeconds, useFlowCountdown } from "./useFlowInactivity";
import "./FlowCountdown.css";

export const LOW_SECONDS = 30;

const FlowCountdown = ({ variant = "inline" }) => {
  const seconds = useFlowCountdown();
  if (seconds === null) return null;
  return (
    <div
      className={`flow-countdown rtl${variant === "fixed" ? " flow-countdown--fixed" : ""}`}
      data-testid="flow-countdown"
    >
      <span className="flow-countdown-text">הזמן שנותר:</span>
      <span className={`flow-countdown-clock${seconds < LOW_SECONDS ? " flow-countdown-clock-low" : ""}`}>
        {formatSeconds(seconds)}
      </span>
    </div>
  );
};

export default FlowCountdown;
